module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2010-08-01",
		"endpointPrefix": "monitoring",
		"protocol": "query",
		"serviceAbbreviation": "CloudWatch",
		"serviceFullName": "Amazon CloudWatch",
		"signatureVersion": "v4",
		"uid": "monitoring-2010-08-01",
		"xmlNamespace": "http://monitoring.amazonaws.com/doc/2010-08-01/"
	},
	"operations": {
		"DeleteAlarms": {
			"input": {
				"type": "structure",
				"required": [
					"AlarmNames"
				],
				"members": {
					"AlarmNames": {
						"shape": "S2"
					}
				}
			}
		},
		"DescribeAlarmHistory": {
			"input": {
				"type": "structure",
				"members": {
					"AlarmName": {},
					"HistoryItemType": {},
					"StartDate": {
						"type": "timestamp"
					},
					"EndDate": {
						"type": "timestamp"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeAlarmHistoryResult",
				"type": "structure",
				"members": {
					"AlarmHistoryItems": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"AlarmName": {},
								"Timestamp": {
									"type": "timestamp"
								},
								"HistoryItemType": {},
								"HistorySummary": {},
								"HistoryData": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeAlarms": {
			"input": {
				"type": "structure",
				"members": {
					"AlarmNames": {
						"shape": "S2"
					},
					"AlarmNamePrefix": {},
					"StateValue": {},
					"ActionPrefix": {},
					"MaxRecords": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeAlarmsResult",
				"type": "structure",
				"members": {
					"MetricAlarms": {
						"shape": "Sj"
					},
					"NextToken": {}
				}
			}
		},
		"DescribeAlarmsForMetric": {
			"input": {
				"type": "structure",
				"required": [
					"MetricName",
					"Namespace"
				],
				"members": {
					"MetricName": {},
					"Namespace": {},
					"Statistic": {},
					"ExtendedStatistic": {},
					"Dimensions": {
						"shape": "Sw"
					},
					"Period": {
						"type": "integer"
					},
					"Unit": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeAlarmsForMetricResult",
				"type": "structure",
				"members": {
					"MetricAlarms": {
						"shape": "Sj"
					}
				}
			}
		},
		"DisableAlarmActions": {
			"input": {
				"type": "structure",
				"required": [
					"AlarmNames"
				],
				"members": {
					"AlarmNames": {
						"shape": "S2"
					}
				}
			}
		},
		"EnableAlarmActions": {
			"input": {
				"type": "structure",
				"required": [
					"AlarmNames"
				],
				"members": {
					"AlarmNames": {
						"shape": "S2"
					}
				}
			}
		},
		"GetMetricStatistics": {
			"input": {
				"type": "structure",
				"required": [
					"Namespace",
					"MetricName",
					"StartTime",
					"EndTime",
					"Period"
				],
				"members": {
					"Namespace": {},
					"MetricName": {},
					"Dimensions": {
						"shape": "Sw"
					},
					"StartTime": {
						"type": "timestamp"
					},
					"EndTime": {
						"type": "timestamp"
					},
					"Period": {
						"type": "integer"
					},
					"Statistics": {
						"type": "list",
						"member": {}
					},
					"ExtendedStatistics": {
						"type": "list",
						"member": {}
					},
					"Unit": {}
				}
			},
			"output": {
				"resultWrapper": "GetMetricStatisticsResult",
				"type": "structure",
				"members": {
					"Label": {},
					"Datapoints": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Timestamp": {
									"type": "timestamp"
								},
								"SampleCount": {
									"type": "double"
								},
								"Average": {
									"type": "double"
								},
								"Sum": {
									"type": "double"
								},
								"Minimum": {
									"type": "double"
								},
								"Maximum": {
									"type": "double"
								},
								"Unit": {},
								"ExtendedStatistics": {
									"type": "map",
									"key": {},
									"value": {
										"type": "double"
									}
								}
							},
							"xmlOrder": [
								"Timestamp",
								"SampleCount",
								"Average",
								"Sum",
								"Minimum",
								"Maximum",
								"Unit",
								"ExtendedStatistics"
							]
						}
					}
				}
			}
		},
		"ListMetrics": {
			"input": {
				"type": "structure",
				"members": {
					"Namespace": {},
					"MetricName": {},
					"Dimensions": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"Name"
							],
							"members": {
								"Name": {},
								"Value": {}
							}
						}
					},
					"NextToken": {}
				}
			},
			"output": {
				"resultWrapper": "ListMetricsResult",
				"type": "structure",
				"members": {
					"Metrics": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Namespace": {},
								"MetricName": {},
								"Dimensions": {
									"shape": "Sw"
								}
							},
							"xmlOrder": [
								"Namespace",
								"MetricName",
								"Dimensions"
							]
						}
					},
					"NextToken": {}
				},
				"xmlOrder": [
					"Metrics",
					"NextToken"
				]
			}
		},
		"PutMetricAlarm": {
			"input": {
				"type": "structure",
				"required": [
					"AlarmName",
					"MetricName",
					"Namespace",
					"Period",
					"EvaluationPeriods",
					"Threshold",
					"ComparisonOperator"
				],
				"members": {
					"AlarmName": {},
					"AlarmDescription": {},
					"ActionsEnabled": {
						"type": "boolean"
					},
					"OKActions": {
						"shape": "So"
					},
					"AlarmActions": {
						"shape": "So"
					},
					"InsufficientDataActions": {
						"shape": "So"
					},
					"MetricName": {},
					"Namespace": {},
					"Statistic": {},
					"ExtendedStatistic": {},
					"Dimensions": {
						"shape": "Sw"
					},
					"Period": {
						"type": "integer"
					},
					"Unit": {},
					"EvaluationPeriods": {
						"type": "integer"
					},
					"Threshold": {
						"type": "double"
					},
					"ComparisonOperator": {},
					"TreatMissingData": {},
					"EvaluateLowSampleCountPercentile": {}
				}
			}
		},
		"PutMetricData": {
			"input": {
				"type": "structure",
				"required": [
					"Namespace",
					"MetricData"
				],
				"members": {
					"Namespace": {},
					"MetricData": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"MetricName"
							],
							"members": {
								"MetricName": {},
								"Dimensions": {
									"shape": "Sw"
								},
								"Timestamp": {
									"type": "timestamp"
								},
								"Value": {
									"type": "double"
								},
								"StatisticValues": {
									"type": "structure",
									"required": [
										"SampleCount",
										"Sum",
										"Minimum",
										"Maximum"
									],
									"members": {
										"SampleCount": {
											"type": "double"
										},
										"Sum": {
											"type": "double"
										},
										"Minimum": {
											"type": "double"
										},
										"Maximum": {
											"type": "double"
										}
									}
								},
								"Unit": {}
							}
						}
					}
				}
			}
		},
		"SetAlarmState": {
			"input": {
				"type": "structure",
				"required": [
					"AlarmName",
					"StateValue",
					"StateReason"
				],
				"members": {
					"AlarmName": {},
					"StateValue": {},
					"StateReason": {},
					"StateReasonData": {}
				}
			}
		}
	},
	"shapes": {
		"S2": {
			"type": "list",
			"member": {}
		},
		"Sj": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"AlarmName": {},
					"AlarmArn": {},
					"AlarmDescription": {},
					"AlarmConfigurationUpdatedTimestamp": {
						"type": "timestamp"
					},
					"ActionsEnabled": {
						"type": "boolean"
					},
					"OKActions": {
						"shape": "So"
					},
					"AlarmActions": {
						"shape": "So"
					},
					"InsufficientDataActions": {
						"shape": "So"
					},
					"StateValue": {},
					"StateReason": {},
					"StateReasonData": {},
					"StateUpdatedTimestamp": {
						"type": "timestamp"
					},
					"MetricName": {},
					"Namespace": {},
					"Statistic": {},
					"ExtendedStatistic": {},
					"Dimensions": {
						"shape": "Sw"
					},
					"Period": {
						"type": "integer"
					},
					"Unit": {},
					"EvaluationPeriods": {
						"type": "integer"
					},
					"Threshold": {
						"type": "double"
					},
					"ComparisonOperator": {},
					"TreatMissingData": {},
					"EvaluateLowSampleCountPercentile": {}
				},
				"xmlOrder": [
					"AlarmName",
					"AlarmArn",
					"AlarmDescription",
					"AlarmConfigurationUpdatedTimestamp",
					"ActionsEnabled",
					"OKActions",
					"AlarmActions",
					"InsufficientDataActions",
					"StateValue",
					"StateReason",
					"StateReasonData",
					"StateUpdatedTimestamp",
					"MetricName",
					"Namespace",
					"Statistic",
					"Dimensions",
					"Period",
					"Unit",
					"EvaluationPeriods",
					"Threshold",
					"ComparisonOperator",
					"ExtendedStatistic",
					"TreatMissingData",
					"EvaluateLowSampleCountPercentile"
				]
			}
		},
		"So": {
			"type": "list",
			"member": {}
		},
		"Sw": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Name",
					"Value"
				],
				"members": {
					"Name": {},
					"Value": {}
				},
				"xmlOrder": [
					"Name",
					"Value"
				]
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/monitoring-2010-08-01.min.json
// module id = 680
// module chunks = 0